import React from 'react';
import LogDateTimeFields from '../../../UI/LogDateTimeFields';

const DateTimeSection = ({ value, onChange }) => {
  return <LogDateTimeFields value={value} onChange={onChange} />;
};

export default DateTimeSection;
